module.exports = __webpack_public_path__ + "img/question.64a0b6a3.svg";